import { cn } from "@utils/tw"
import { ResponsiveImageFragment } from "../../types.graphql"
import { ResponsiveImage } from "./ResponsiveImage"
import { Themed } from "./Themed"
import { Link } from "eddev/routing"

export const TextImageThemeTile = ({
  theme,
  children,
  image,
  imageClassName = "",
  link,
  edge = false,
}: {
  theme: string
  children?: React.ReactNode
  image?: ResponsiveImageFragment
  imageClassName?: string
  link?: { url: string; target?: string }
  edge?: boolean
}) => {
  const Wrap = link ? Link : "div"
  const wrapProps = link ? { href: link.url, target: link.target || undefined } : {}

  return (
    <div className={cn("grid-auto mt-2 mb-5")}>
      <Themed theme={theme || "none"} className="col-span-12 md:col-span-8 md:col-start-3 w-full">
        <Wrap {...wrapProps} className={cn("flex flex-col md:flex-row gap-4 md:gap-8", link && "group/linked")}>
          <div className="w-full flex flex-col gap-7 p-6">{children}</div>
          <div
            className={cn(
              "w-full md:w-2/5 shrink-0 flex self-stretch min-h-[250px]",
              edge ? "px-6" : "p-6",
              imageClassName,
            )}
          >
            {image ? (
              <ResponsiveImage
                srcSet={image.srcSet}
                className={cn("!aspect-video w-full", edge && "h-full")}
                objectFit={edge ? "cover" : "contain"}
                objectPosition="center"
              />
            ) : (
              env.admin && (
                <div className="w-full h-0 pt-[125%] bg-grey1 border border-dashed border-black relative">
                  <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">Image</div>
                </div>
              )
            )}
          </div>
        </Wrap>
      </Themed>
    </div>
  )
}
